/**
 * @author wangtao
 * @date 2025/11/06
 * @file rn-webview-javascript-bridge
 * @desc React Native WebView Bridge 实现，参考 iOS/Android 的 callbackId 机制
 */
/* eslint-disable */
/* globals window */
/* globals document */

export default function () {
    // 检查是否已经初始化
    if (window.WebViewJavascriptBridge) {
        return;
    }

    // 必须在RN环境中才能使用
    if (!window.ReactNativeWebView) {
        return;
    }

    var receiveMessageQueue = [];
    var messageHandlers = {};

    var responseCallbacks = {};
    var uniqueId = 1;

    // 统一的消息处理函数
    function handleRNMessage(event) {
        var messageJSON;
        if (typeof event.data === 'string') {
            messageJSON = event.data;
        } else {
            try {
                messageJSON = JSON.stringify(event.data);
            } catch (exception) {
                if (typeof console != 'undefined') {
                    console.log("WebViewJavascriptBridge: WARNING: failed to stringify message.", event.data, exception);
                }
                return;
            }
        }

        // window/document 上的 message 事件可能来自第三方脚本或宿主注入，
        // event.data 为空（含 undefined，JSON.stringify(undefined) 返回 undefined）时直接丢弃，
        // 否则会走到 JSON.parse(undefined) 抛 SyntaxError。
        if (!messageJSON) {
            return;
        }

        if (receiveMessageQueue) {
            receiveMessageQueue.push(messageJSON);
        } else {
            _dispatchMessageFromNative(messageJSON);
        }
    }

    // set default messageHandler
    function init(messageHandler) {
        if (WebViewJavascriptBridge._messageHandler) {
            throw new Error('WebViewJavascriptBridge.init called twice');
        }
        WebViewJavascriptBridge._messageHandler = messageHandler;
        var receivedMessages = receiveMessageQueue;
        receiveMessageQueue = null;
        for (var i = 0; i < receivedMessages.length; i++) {
            _dispatchMessageFromNative(receivedMessages[i]);
        }
    }

    function send(data, responseCallback) {
        _doSend({
            data: data
        }, responseCallback);
    }

    function registerHandler(handlerName, handler) {
        messageHandlers[handlerName] = handler;
    }

    function callHandler(handlerName, data, responseCallback) {
        _doSend({
            handlerName: handlerName,
            data: data
        }, responseCallback);
    }

    // 发送消息到RN
    function _doSend(message, responseCallback) {
        if (responseCallback) {
            var callbackId = 'cb_' + (uniqueId++) + '_' + new Date().getTime();
            responseCallbacks[callbackId] = responseCallback;
            message.callbackId = callbackId;
        }

        // 通过 ReactNativeWebView.postMessage 发送消息
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }

    // 处理来自RN的消息
    function _dispatchMessageFromNative(messageJSON) {
        setTimeout(function () {
            if (!messageJSON) {
                return;
            }

            var message;
            try {
                message = JSON.parse(messageJSON);
            } catch (exception) {
                if (typeof console != 'undefined') {
                    console.log("WebViewJavascriptBridge: WARNING: failed to parse message.", messageJSON, exception);
                }
                return;
            }

            // 只处理对象型桥接消息，隔离第三方脚本发来的非桥接内容
            if (!message || typeof message !== 'object' || Array.isArray(message)) {
                return;
            }

            var responseCallback;
            // RN call finished, now need to call js callback function
            if (message.responseId) {
                responseCallback = responseCallbacks[message.responseId];
                if (!responseCallback) {
                    return;
                }
                responseCallback(message.responseData);
                delete responseCallbacks[message.responseId];
            } else {
                // 直接发送
                if (message.callbackId) {
                    var callbackResponseId = message.callbackId;
                    responseCallback = function (responseData) {
                        _doSend({
                            responseId: callbackResponseId,
                            responseData: responseData
                        });
                    };
                }

                var handler = WebViewJavascriptBridge._messageHandler;
                if (message.handlerName) {
                    handler = messageHandlers[message.handlerName];
                }
                // 查找指定handler
                try {
                    handler(message.data, responseCallback);
                } catch (exception) {
                    if (typeof console != 'undefined') {
                        console.log("WebViewJavascriptBridge: WARNING: javascript handler threw.", message, exception);
                    }
                }
            }
        });
    }

    var WebViewJavascriptBridge = window.WebViewJavascriptBridge = {
        init: init,
        send: send,
        registerHandler: registerHandler,
        callHandler: callHandler,
        _dispatchMessageFromNative: _dispatchMessageFromNative
    };

    // 监听来自RN的消息
    document.addEventListener('message', handleRNMessage);
    window.addEventListener('message', handleRNMessage);

    // 触发ready事件
    var doc = document;
    var readyEvent = doc.createEvent('Events');
    readyEvent.initEvent('WebViewJavascriptBridgeReady');
    readyEvent.bridge = WebViewJavascriptBridge;
    doc.dispatchEvent(readyEvent);
}

